import callApi from '../../util/apiCaller';

export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export function requestForgotPassword() {
  return {
    type: REQUEST_FORGOT_PASSWORD,
    isFetching: true,
  };
}

export function sendFailedResponse(message) {
  return {
    type: FORGOT_PASSWORD_FAILURE,
    isFetching: false,
    message: message,
  };
}

export function sendSuccessResponse(message) {
  return {
    type: FORGOT_PASSWORD_SUCCESS,
    isFetching: false,
    message: message,
  };
}

export function requestResetPassword() {
  return {
    type: REQUEST_RESET_PASSWORD,
    isFetching: true,
  };
}

export function sendResetFailedResponse(message) {
  return {
    type: RESET_PASSWORD_FAILURE,
    isFetching: false,
    message: message,
  };
}

export function sendResetSuccessResponse(message) {
  return {
    type: RESET_PASSWORD_SUCCESS,
    isFetching: false,
    message: message,
  };
}

export function forgotUserPassword(creds) {
  return (dispatch) => {
    dispatch(requestForgotPassword());
    return callApi(`auth/forgot`, 'post', creds)
      .then(res => {
        const { user, message } = res;
        if (!user.ok) {
          dispatch(sendFailedResponse(message));
          return Promise.reject(message);
        } else {
          dispatch(sendSuccessResponse(message));
        }
      });
  };
}

export function getUserByUserToken(id) {
  return (dispatch) => {
    return callApi(`auth/reset/${id}`, 'get')
      .then(res => {
        const { user, message } = res;
        if (!user.ok) {
          dispatch(sendResetFailedResponse(message));
        } else {
          dispatch(sendResetSuccessResponse(message));
        }
      });
  };
}

export function resetPasswordForUserToken(data) {
  return (dispatch) => {
    dispatch(requestResetPassword());
    return callApi(`auth/reset/${data.id}`, 'post', {
      password: data.password,
    })
      .then(res => {
        const { user, message } = res;
        if (!user.ok) {
          dispatch(sendResetFailedResponse(message));
          return Promise.reject(message);
        }
        dispatch(sendResetSuccessResponse('Password saved successfully!'));
        // window.location = '/login?reset=ok';
      });
  };
}
